<div
  class="flex items-center gap-x-1 whitespace-nowrap"
  role="img"
  [attr.aria-label]="ariaLabel"
  [title]="ariaLabel"
  data-testid="cardStrength"
>
  <span
    class="relative overflow-hidden rounded-sm h-1 w-11 bg-project-50"
    aria-hidden="true"
    data-testid="strengthTrack"
  >
    <span
      class="absolute left-0 rounded-sm inset-y-0"
      [ngClass]="fillClass"
      [style.width.%]="fillPercent"
      data-testid="strengthFill"
    ></span>
  </span>
  <!-- text-xxs carries no paired line-height, so leading is pinned here. -->
  <span
    class="font-semibold text-xxs leading-4 tabular-nums"
    [ngClass]="textClass"
    data-testid="strengthConfidence"
    >{{ confidenceLabel }}</span
  >
</div>
